var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.is_show)?_c('div',{staticClass:"absolute bottom-24"},[_c('div',{staticClass:"badge text-white d-flex justify-content-center align-items-center rw-bg-3 cursor-pointer",on:{"click":_vm.toBottom}},[_c('span',{staticClass:"material-symbols-outlined text-sm"},[_vm._v("south")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }